const videoText = {
  en: {
    videoPlayer: 'Press the space bar or K to toggle play and pause. Use the left and right arrow keys or the comma and period keys to scrub through the video. Use the up and down arrow keys, the dash and equal keys, or the add and subtract number pad keys to increase and decrease volume. Press M to toggle mute. Press F to toggle fullscreen. Press escape to exit instructions and return to video.',
    videoSelected: 'Video selected. Press Q to listen to controls.',
    videoSelectedSimple: 'Video selected. Press the space bar or K to toggle play and pause.',
    mute: 'Mute',
    unmute: 'Unmute',
    watch: 'Watch the video',
    replay: 'Replay the video',
    itemSelected: 'This is the currently selected option.',
    itemUnselected: 'Select to switch to this option.',
    captionsToggle: 'Select captions',
    captionsDialogue: 'Captions',
    captionsNone: 'None',
    qualityToggle: 'Change video quality',
    qualityDialogue: 'Quality',
    fullScreenToggle: 'Toggle fullscreen',
    minute: 'minute',
    minutes: 'minutes',
    second: 'second',
    seconds: 'seconds',
    ariaLabel: 'Play video. Video length is {minutes} and {seconds}.',
    volumeSliderLabel: 'Adjust the volume',
    videoProgressBarLabel: 'Progress bar',
    en: 'English',
    fr: 'French'
  },
  fr: {
    videoPlayer: 'Appuyer sur K pour basculer entre lecture et pause. Utiliser les flèches gauche et droite ou les touches virgule et point pour reculer ou faire une avance rapide dans la vidéo. Utiliser les flèches ascendante et descendante, les touches tiret et égal ou les touches plus et moins du clavier numérique pour contrôler le volume. Appuyer sur la touche M pour désactiver le son. Appuyer sur F pour basculer en mode plein écran. Appuyer sur la touche d’échappement pour quitter les instructions et retourner à la vidéo.',
    videoSelected: 'Vidéo sélectionnée. Appuyer sur Q pour écouter les contrôles',
    videoSelectedSimple: 'Vidéo sélectionnée. Appuyer sur K pour basculer entre lecture et pause.',
    mute: 'Désactiver le son',
    unmute: 'Activer le son',
    watch: 'Voir la vidéo',
    replay: 'Relire la vidéo',
    itemSelected: 'Cette option est déjà sélectionnée.',
    itemUnselected: 'Sélectionner pour basculer à cette option.',
    captionsToggle: 'Sélectionner les sous-titres',
    captionsDialogue: 'Sous-titres',
    captionsNone: 'Aucun',
    qualityToggle: 'Modifier la qualité de la vidéo',
    qualityDialogue: 'Qualité',
    fullScreenToggle: 'Basculer en mode plein écran',
    minute: 'minute',
    minutes: 'minutes',
    second: 'seconde',
    seconds: 'secondes',
    ariaLabel: 'Lire la vidéo. La durée de la vidéo est de {minutes} et {seconds}.',
    volumeSliderLabel: 'Réglez le volume',
    videoProgressBarLabel: 'Barre de progression',
    en: 'Anglais',
    fr: 'Français'
  }
};
export default videoText;